import React from "react";

export function SettingsPage({
	name,
	onNameChange,
	soundOn,
	onSoundOnChange,
	volume,
	onVolumeChange,
	crtEffect,
	onCrtEffectChange,
	onBack,
}: {
	name: string;
	onNameChange: (name: string) => void;
	soundOn: boolean;
	onSoundOnChange: (on: boolean) => void;
	volume: number;
	onVolumeChange: (volume: number) => void;
	crtEffect: boolean;
	onCrtEffectChange: (on: boolean) => void;
	onBack: () => void;
}) {
	return (
		<div className="App settings-screen">
			<h1>Settings</h1>
			<div className="pixel-panel pixel-frame settings-panel">
				<div className="field-pixel">
					<label htmlFor="settings-name">Racer Name</label>
					<input
						id="settings-name"
						type="text"
						placeholder="Your name"
						value={name}
						onChange={(event) => onNameChange(event.target.value)}
					/>
				</div>

				<hr className="menu-divider" />

				<div className="settings-row">
					<label className="toggle-pixel" htmlFor="settings-sound">
						Sound
						<input
							id="settings-sound"
							type="checkbox"
							checked={soundOn}
							onChange={(event) => onSoundOnChange(event.target.checked)}
						/>
					</label>
				</div>

				<div className="field-pixel">
					<label htmlFor="settings-volume">Volume — {volume}%</label>
					<input
						id="settings-volume"
						className="range-pixel"
						type="range"
						min={0}
						max={100}
						step={5}
						value={volume}
						disabled={!soundOn}
						onChange={(event) => onVolumeChange(Number(event.target.value))}
					/>
				</div>

				<hr className="menu-divider" />

				<div className="settings-row">
					<label className="toggle-pixel" htmlFor="settings-crt">
						CRT Scanlines
						<input
							id="settings-crt"
							type="checkbox"
							checked={crtEffect}
							onChange={(event) => onCrtEffectChange(event.target.checked)}
						/>
					</label>
				</div>

				<hr className="menu-divider" />

				<h3>Controls</h3>
				<div className="controls-card">
					<dl>
						<dt>LEFT / A</dt>
						<dd>Move left</dd>
						<dt>RIGHT / D</dt>
						<dd>Move right</dd>
						<dt>UP / W / SPACE</dt>
						<dd>Jump</dd>
						<dt>ESC</dt>
						<dd>Pause (solo)</dd>
					</dl>
				</div>
			</div>

			<button className="btn-pixel btn-pixel--ghost" onClick={onBack}>
				Back
			</button>
		</div>
	);
}
